<template>
    <div>
        <nav
            v-if="CTabs.length"
            class="border-b text-lg flex justify-start space-x-2 mb-2">
            <template
                v-for="(tab, index) in CTabs"
                :key="index">
                <div
                    v-if="!exclude.includes(tab[keyId])"
                    class="inline-block text-gray-700 cursor-pointer"
                    :class="{
                        'transition-transform border-b-2 border-main-600 text-main-600': checkActive(tab[keyId]),
                        'px-2 py-1 text-sm': size === 'small',
                        'px-4 py-2': size !== 'small'
                    }"
                    @click="handleClick(tab[keyId])">
                    <slot v-bind="tab">
                        <span>
                            {{ tab[labelId] }}
                        </span>
                    </slot>
                </div>
            </template>
        </nav>
        <slot :tab="activeTab" />
    </div>
</template>

<script lang="ts" setup>
import { checkPermission } from '@/utils/permission-check'

const props = defineProps({
  modelValue: { type: [Array, String], default: () => '' },
  tabs: { type: Array as PropType<{ [key: string]: any }>, required: true },
  type: { type: String },
  typeDetail: { type: String },
  size: { type: String },
  keyId: {
    type: String,
    default: 'key'
  },
  labelId: {
    type: String,
    default: 'label'
  },
  exclude: {
    type: Array,
    default: () => []
  }
})

const emits = defineEmits(['update:modelValue', 'click'])

const { tabs, exclude, keyId, labelId, modelValue, size } = toRefs(props)
const activeTab = computed({
  get () {
    return modelValue.value
  },
  set (val: any) {
    emits('update:modelValue', val)
  }
})
const handleClick = (key: string) => {
  activeTab.value = key
  emits('click', key)
}

const checkActive = (key: string) => {
  return activeTab.value === key
}

const CTabs = computed(() => {
  if (tabs.value.length) {
    return tabs.value.filter((tab: { [key: string]: any }) => {
      if (typeof tab.permission === 'string' || Array.isArray(tab.permission)) {
        tab.permission = checkPermission(tab.permissions || [], tab.justOnePermission)
        console.log(' tab.permission', tab.permission)
      }
      return tab.permission === undefined || tab.permission
    })
  }
  return []
})

onBeforeMount(() => {
  if (modelValue.value) {
    activeTab.value = String(modelValue.value)
    return
  }

  if (tabs.value.length) {
    const defaultActive: { [key: string]: any } = CTabs.value.find((i: any) => {
      return i.active && (i.permission === undefined || i.permission)
    }) as { [key: string]: any }
    if (defaultActive) {
      activeTab.value = defaultActive[keyId.value]
    } else {
      const defaultActive: { [key: string]: any } = CTabs.value.find((i: any) => {
        return i.permission === undefined || i.permission
      }) as { [key: string]: any }
      activeTab.value = defaultActive ? defaultActive[keyId.value] : ''
    }
  }
})
</script>
